import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"add\"><path fill-rule=\"evenodd\" d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol